import { useMutation } from '@tanstack/react-query';
import { operationApis } from '../../../../../../../shared/apis/operation/apis';

export function useUploadPopupImages() {
  const { mutateAsync: uploadPopupImage } = useMutation(operationApis.uploadPopupImage);

  return { uploadPopupImage };
}
